/**
 * 会員価格再計算スクリプト
 * バリアント変更時に会員価格を自動的に再計算します
 */

(function() {
  'use strict';

  // ページ読み込み時、すぐに「計算中...」を表示
  function showCalculatingState() {
    console.log('[会員価格] 計算中表示を開始');
    // data-calculating属性の有無に関わらず、すべての会員価格要素を対象にする
    const memberPriceElements = document.querySelectorAll('.price-item--member');
    console.log('[会員価格] 会員価格要素数:', memberPriceElements.length);
    
    memberPriceElements.forEach((el, index) => {
      const valueEl = el.querySelector('.member-price-value');
      const calcEl = el.querySelector('.member-price-calculating');
      
      console.log(`[会員価格] 要素${index}:`, {
        hasValueEl: !!valueEl,
        hasCalcEl: !!calcEl,
        innerHTML: el.innerHTML.substring(0, 100)
      });
      
      if (valueEl && calcEl) {
        valueEl.style.display = 'none';
        calcEl.style.display = 'inline';
        el.style.opacity = '0.6';
        el.setAttribute('data-calculating', 'true'); // 属性を再設定
        console.log(`[会員価格] 要素${index}: 計算中表示に切り替えました`);
      } else {
        console.log(`[会員価格] 要素${index}: 構造が見つかりません。通常の方法で計算中表示します`);
        // フォールバック：構造がない場合は直接書き換え
        el.style.opacity = '0.6';
        const bdiEl = el.querySelector('bdi');
        if (bdiEl) {
          if (!bdiEl.dataset.originalPrice) {
            bdiEl.dataset.originalPrice = bdiEl.textContent;
          }
          bdiEl.textContent = '計算中...';
          console.log(`[会員価格] 要素${index}: bdiを直接書き換えました`);
        }
      }
    });
  }

  // 「計算中...」を非表示にして価格を表示
  function hideCalculatingState() {
    console.log('[会員価格] 計算中表示を非表示にします');
    const memberPriceElements = document.querySelectorAll('.price-item--member');
    memberPriceElements.forEach((el, index) => {
      const valueEl = el.querySelector('.member-price-value');
      const calcEl = el.querySelector('.member-price-calculating');
      if (valueEl && calcEl) {
        valueEl.style.display = 'inline';
        calcEl.style.display = 'none';
        el.style.opacity = '1';
        el.removeAttribute('data-calculating');
        console.log(`[会員価格] 要素${index}: 構造を使って非表示にしました`);
      } else {
        // フォールバック：構造がない場合は単にopacityを戻す
        el.style.opacity = '1';
        console.log(`[会員価格] 要素${index}: opacityのみ戻しました`);
      }
    });
  }

  // ページ読み込み直後に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showCalculatingState);
  } else {
    showCalculatingState();
  }

  function recalculateMemberPrice() {
    try {
      console.log('[会員価格] 再計算開始', new Date().toLocaleTimeString());
      
      // 全ての価格コンテナを取得
      const priceElements = document.querySelectorAll('.price--on-sale, .price--member');
      console.log('[会員価格] 価格要素数:', priceElements.length);
      
      priceElements.forEach((priceElement, index) => {
        const regularPriceEl = priceElement.querySelector('.price-item--regular price-money bdi');
        const memberPriceEl = priceElement.querySelector('.price-item--member price-money bdi');
        const badgeEl = priceElement.querySelector('.badge');

        if (!regularPriceEl || !memberPriceEl || !badgeEl) {
          console.log(`[会員価格] 要素${index}: 必要な要素が見つかりません`);
          return;
        }

        // バッジから割引率を取得
        const badgeText = badgeEl.textContent;
        if (!badgeText.includes('%OFF')) {
          console.log(`[会員価格] 要素${index}: バッジに%OFFが含まれていません`);
          return;
        }

        const discountMatch = badgeText.match(/(\d+)%OFF/);
        if (!discountMatch) return;

        const discountPercentage = parseInt(discountMatch[1]);

        // 通常価格を取得（テキストから数字のみを抽出）
        const priceText = regularPriceEl.textContent.replace(/[^\d]/g, '');
        const regularPrice = parseInt(priceText);

        if (!regularPrice || isNaN(regularPrice)) {
          console.log(`[会員価格] 要素${index}: 通常価格が取得できません`);
          return;
        }

        // 会員価格を計算
        const memberPrice = Math.round(regularPrice * (100 - discountPercentage) / 100);

        // 現在の会員価格を取得
        const currentMemberPriceText = memberPriceEl.textContent.replace(/[^\d]/g, '');
        const currentMemberPrice = parseInt(currentMemberPriceText);

        console.log(`[会員価格] 要素${index}: 通常価格=${regularPrice}, 割引率=${discountPercentage}%, 会員価格=${memberPrice}, 現在の表示=${currentMemberPrice}`);

        // 「計算中...」が表示されている場合はスキップしない
        if (memberPriceEl.textContent.includes('計算中')) {
          console.log(`[会員価格] 要素${index}: 計算中状態なので更新します`);
        } else if (currentMemberPrice === memberPrice && !isNaN(currentMemberPrice)) {
          console.log(`[会員価格] 要素${index}: 既に正しい価格です`);
          return;
        }

        // より確実な更新方法：bdi要素全体を書き換える
        if (memberPriceEl.textContent === '計算中...' || /\d/.test(memberPriceEl.textContent)) {
          memberPriceEl.textContent = memberPrice.toLocaleString('ja-JP');
          console.log(`[会員価格] 要素${index}: 価格を更新しました ${currentMemberPrice} → ${memberPrice}`);
        } else {
          // テキストノードを探して更新（従来の方法）
          memberPriceEl.childNodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE) {
              const text = node.textContent.trim();
              if (/\d/.test(text) || text === '計算中...') {
                node.textContent = memberPrice.toLocaleString('ja-JP');
                console.log(`[会員価格] 要素${index}: 価格を更新しました (テキストノード) ${currentMemberPrice} → ${memberPrice}`);
              }
            }
          });
        }
        
        // opacityを元に戻す
        const memberPriceContainer = priceElement.querySelector('.price-item--member');
        if (memberPriceContainer) {
          memberPriceContainer.style.opacity = '1';
        }
      });
      
      // 計算完了後、「計算中...」を非表示にする
      hideCalculatingState();

    } catch (error) {
      console.error('会員価格の計算エラー:', error);
    }
  }

  // variant-selectsのカスタムイベントをリッスン
  document.addEventListener('variant:change', function(event) {
    console.log('[会員価格] variant:changeイベント検知', new Date().toLocaleTimeString(), event);
    
    // Shopifyの価格更新が完了するまで少し待つ
    setTimeout(() => {
      console.log('[会員価格] Shopifyの価格更新完了後、計算中表示を開始');
      showCalculatingState();
      
      // GPOが価格を書き換える可能性があるので、もう一度表示
      setTimeout(() => {
        console.log('[会員価格] 念のため、もう一度計算中表示');
        showCalculatingState();
      }, 200);
      
      // GPOアプリの処理完了を待つため長めの遅延
      setTimeout(() => {
        console.log('[会員価格] variant:change後の遅延完了。会員価格を再計算します');
        recalculateMemberPrice();
      }, 800);
    }, 200); // Shopifyの更新を待つ
  });

  // price要素のみを監視（軽量版）
  let updateTimeout = null;
  let mutationCount = 0;
  let observer = null;
  let isUpdating = false; // 更新中フラグ
  
  function setupPriceObserver() {
    const priceContainers = document.querySelectorAll('[id^="price-"]');
    
    if (priceContainers.length === 0) {
      console.log('[会員価格] 価格コンテナが見つかりません');
      return;
    }
    
    console.log('[会員価格] MutationObserver設定完了。監視対象:', priceContainers.length, '個');
    
    observer = new MutationObserver((mutations) => {
      // 自分自身による更新中は無視
      if (isUpdating) {
        console.log('[会員価格] 自分自身による変更を無視');
        return;
      }
      
      if (updateTimeout) clearTimeout(updateTimeout);
      mutationCount++;
      
      console.log(`[会員価格] DOM変更検知 #${mutationCount}`, new Date().toLocaleTimeString(), '変更数:', mutations.length);
      
      // GPOアプリが複数回価格を更新する可能性があるため
      // 最後の変更から1秒後に実行（GPOの処理完了を待つ）
      updateTimeout = setTimeout(() => {
        console.log(`[会員価格] DOM変更が落ち着きました（合計${mutationCount}回）。会員価格を再計算します`);
        
        // 監視を一時停止
        isUpdating = true;
        observer.disconnect();
        
        // 計算中表示
        showCalculatingState();
        
        // 少し遅延してから計算実行
        setTimeout(() => {
          recalculateMemberPrice();
          
          // 監視を再開
          setTimeout(() => {
            priceContainers.forEach((container) => {
              observer.observe(container, {
                childList: true,
                subtree: true,
                characterData: true,
                characterDataOldValue: true
              });
            });
            isUpdating = false;
            console.log('[会員価格] 監視を再開しました');
          }, 100);
        }, 50);
        
        mutationCount = 0;
      }, 1000);
    });

    priceContainers.forEach((container, index) => {
      console.log(`[会員価格] 監視開始: コンテナ#${index} (ID: ${container.id})`);
      observer.observe(container, {
        childList: true,
        subtree: true,
        characterData: true,
        characterDataOldValue: true
      });
    });
    
    // 監視開始後、即座に会員価格を再計算（GPOで上書きされた価格を修正）
    console.log('[会員価格] 監視開始後、即座に会員価格を再計算します');
    
    // 既に「計算中...」は表示されているので、すぐに計算開始
    setTimeout(() => {
      // 初回の更新も監視を一時停止して実行
      isUpdating = true;
      observer.disconnect();
      
      recalculateMemberPrice();
      
      // 監視を再開
      setTimeout(() => {
        priceContainers.forEach((container) => {
          observer.observe(container, {
            childList: true,
            subtree: true,
            characterData: true,
            characterDataOldValue: true
          });
        });
        isUpdating = false;
        console.log('[会員価格] 初回更新完了。監視を再開しました');
      }, 100);
    }, 100);
  }

  // 初期化
  console.log('[会員価格] スクリプト読み込み完了。document.readyState:', document.readyState);
  
  if (document.readyState === 'loading') {
    console.log('[会員価格] DOMContentLoadedイベントを待ちます');
    document.addEventListener('DOMContentLoaded', () => {
      console.log('[会員価格] DOMContentLoadedイベント発火');
      // GPOアプリの初期化完了を待つため、さらに遅延
      setTimeout(() => {
        console.log('[会員価格] GPOアプリの初期化完了を待機後、監視を開始');
        setupPriceObserver();
      }, 2000);
    });
  } else {
    console.log('[会員価格] DOMは既に読み込み完了。GPOの初期化を待ってからセットアップ');
    // GPOアプリの初期化完了を待つため、遅延
    setTimeout(() => {
      console.log('[会員価格] GPOアプリの初期化完了を待機後、監視を開始');
      setupPriceObserver();
    }, 2000);
  }

})();

